import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '',
    component: () => import(/* webpackChunkName: "about" */ '../views/index.vue'),
    redirect: '/home/index',
    children: [
      {
        path: '/home/index',
        name: 'homePage',
        component: () => import(/* webpackChunkName: "about" */ '../views/home/index.vue')
      },
      {
        path: '/about/index',
        name: 'about',
        component: () => import(/* webpackChunkName: "about" */ '../views/about/index.vue')
      },
      {
        path: '/solution/index',
        name: 'solution',
        component: () => import(/* webpackChunkName: "about" */ '../views/solution/index.vue')
      },
      {
        path: '/product/index',
        name: 'product',
        component: () => import(/* webpackChunkName: "about" */ '../views/product/index.vue')
      },
      {
        path:'/mes-system/index',
        name:'mes-system',
        component: () => import(/* webpackChunkName: "about" */ '../views/product/modules/mes_system.vue')
      },
      {
        path:'/customer-case/details',
        name:'customer-case-details',
        component: () => import(/* webpackChunkName: "about" */ '../views/customer-case/detail/detail.vue')
      }
    ]
  },

  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // },
]

const router = new VueRouter({
  routes
})

export default router
